// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"2579c0ed","453":"e1a8a138","777":"8dd5f376"}[chunkId] + ".chunk.js";
};